import { ScheduleList } from '../components/Schedules/ScheduleList';

export function SchedulesPage() {
  return <ScheduleList />;
}
